// extracted by mini-css-extract-plugin
export var avatarContainer = "_6x-0";
export var avatarTypingWave = "_6x-i";
export var gray = "_6x-f";
export var green = "_6x-c";
export var icon = "_6x-9";
export var image = "_6x-1";
export var lg = "_6x-6";
export var md = "_6x-5";
export var presenceDot = "_6x-b";
export var red = "_6x-d";
export var sm = "_6x-4";
export var status = "_6x-a";
export var typingDot = "_6x-h";
export var typingPill = "_6x-g";
export var xl = "_6x-7";
export var xs = "_6x-3";
export var xxl = "_6x-8";
export var xxs = "_6x-2";
export var yellow = "_6x-e";